import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";

export class DFAvalancheIdlePresentation implements FlowStatePresentation {
    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => flowStateController.finish()
        });
        tl.add(() => SlotGame.apiPlugin.betHandler.zeroBet());
        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }
}